export { useAuth, AuthProvider } from '@/tools/auth/ui/client/AuthContext'

export { getServerCredentials } from './ui/server'

export {
  initAuth,
  refresh,
  signOut,
  signIn,
  getAuthenticationMethods, //todo depracate this
  validateTwoFactor,
  setCredentialsAndAuthorization,
  getCredentials,
} from './session'
export type { GrantType, AuthenticationMethods, AuthTokenPayload, Credentials } from './session'
